module.exports = __webpack_public_path__ + "static/media/IconMoveRow.d5a03737.svg";